module.exports = __webpack_public_path__ + "img/Nelson-Vidal.e890eda2.jpg";